const useFirmInfo = () => {

  const isStaleAggregation = (agg) => {
    if (!agg?.year) {
      return true;
    }

    const today = new Date();

    if (agg.month != null) {
      const aggDate = new Date(Number(agg.year), Number(agg.month) - 1, 1);

      const monthsDiff =
        (today.getFullYear() * 12 + today.getMonth() + 1) -
        (aggDate.getFullYear() * 12 + aggDate.getMonth() + 1);

      return monthsDiff > 24;
    }

    return (today.getFullYear() - Number(agg.year)) > 2;
  };

  const nilIfZero = (value) => {
    return Number(value) === 0 ? null : value;
  };

  const shouldAverage = (records) => {
    if (records.length < 2) {
      return false;
    }
    return records.some(a => a.month == null);
  };

  const averageField = (records, field) => {
    const values = records.map(a => Number(a[field] ?? 0));
    if (!values.length) {
      return null;
    }
    return Math.floor(values.reduce((s, v) => s + v, 0) / values.length);
  };

  const latestValue = (records, field) => {
    const sorted = [...records].sort((a, b) => {
      const keyA = [
        Number(a.year),
        a.month != null ? 1 : 0,
        Number(a.month ?? 0),
      ];
      const keyB = [
        Number(b.year),
        b.month != null ? 1 : 0,
        Number(b.month ?? 0),
      ];

      for (let i = 0; i < keyA.length; i++) {
        if (keyB[i] !== keyA[i]) return keyB[i] - keyA[i];
      }
      return 0;
    });

    return sorted[0]?.[field] ?? null;
  };

  const resolveMetric = (aggregations = [], field) => {
    if (!aggregations.length) {
      return null;
    }

    const fresh = aggregations.filter(a => !isStaleAggregation(a));
    if (!fresh.length) {
      return null;
    }

    const freshWithValue = fresh.filter(a => {
      const v = a[field];
      return v !== null && v !== undefined && v !== '';
    });
    if (!freshWithValue.length) {
      return null;
    }

    const latestYear = Math.max(
      ...freshWithValue.map(a => Number(a.year ?? 0))
    );

    const latestYearRecords = freshWithValue.filter(
      a => Number(a.year) === latestYear
    );
    if (!latestYearRecords.length) {
      return null;
    }

    if (shouldAverage(latestYearRecords)) {
      return averageField(latestYearRecords, field);
    }

    return latestValue(latestYearRecords, field);
  };

  const getFirmAumAggregationInfo = (aumAggregations = []) => {
    const totalAum = nilIfZero(
      resolveMetric(aumAggregations, 'total_aum')
    );

    const minimumAccountSize = nilIfZero(
      resolveMetric(aumAggregations, 'minimum_account_size')
    );

    return {
      total_aum: totalAum ?? '',
      minimum_account_size: minimumAccountSize ?? '',
    };
  };

  return { getFirmAumAggregationInfo };
};

export default useFirmInfo;
